import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';

import { ExplorableItemType } from '../../spacesPlatform/models/ContentType';
import { ContentDraftStatus } from '../serverApi/types/ContentDraft';

export enum ParentContentType {
  PublishedWorkbook = 'PUBLISHED_WORKBOOK',
  UnpublishedWorkbook = 'UNPUBLISHED_WORKBOOK',
}

export enum ContainerType {
  PersonalSpace = 'PERSONAL_SPACE',
  Project = 'PROJECT',
  Unknown = 'UNKNOWN',
}

export interface Draft {
  containerLuid: string;
  containerType: ContainerType;
  createdAt: string;
  draftLuid: string;
  name: string;
  parentContentLuid: string;
  parentId: string;
  parentRevisionId: string;
  parentType: ParentContentType;
  siteLuid: string;
  snapshotTimelineId: string;
  thumbnailURL: string;
  updatedAt: string;
  userLuid: string;
}

export interface WorkbookDraftContent {
  contentType: ExplorableItemType;
  createdAt: Date;
  draftLuid: string;
  draftStatus: ContentDraftStatus;
  editUrl?: string;
  id: string;
  name: string;
  owner?: IUserInfo;
  parentId: string;
  thumbnailUrl: string;
  updatedAt: Date;
}

export const WorkbookDraftContentType: ExplorableItemType = 'workbook';

export type GetDraftsRequestBody = Blob;

export enum DraftTagsParentType {
  card = 'CARD',
  list = 'LIST',
  none = 'NONE'
}

export enum DraftTagType {
  neverPublished = 'NEVER_PUBLISHED',
  unpublished = 'DRAFT',
  staticTag = 'STATIC_TAG'  // for draft tags that should not have a tooltip
}

// Drafts state
export type DraftsById = { [key: string]: Draft } | null;

export interface DraftsState {
  readonly drafts: DraftsById;
  readonly isBusy: boolean;
}

export interface DraftWorkbookSpaceProps {
  draftUpdatedAt: string;
  draftLuid: string;
}

// Generated from printing out a 404 error
// Don't go around using this blindly
export interface SpringError {
  summary: string;
  callstack: string;
  code: string;
  detail: string;
}

export interface SpringResponse {
  error: SpringError;
}
